import { RenderOptions } from '../../../common/zoom/models/render-options';
import { CirclePacking } from '../../models/circlePackingModel';
import { MAIN_DEPTH } from '../constants';
import { textRender } from '../render/textRender';

/**
 *
 * @param circlesPacking Hierarchical data
 * @param context canvas context
 * @param actualDepth actual level rendered
 * @param formatValue pipe to format values
 * @param renderValue
 */
export const textRenderRecursive: (
  circlesPacking: Array<CirclePacking>,
  context: CanvasRenderingContext2D,
  actualDepth: number,
  formatValue: (num: number) => string,
  renderOptions: RenderOptions
) => void = (circlesPacking, context, actualDepth, formatValue, renderOptions) => {
  (circlesPacking || []).forEach((circle) => {
    if (MAIN_DEPTH === circle.depth) {
      textRender(circle, context, formatValue(circle.doc_count), renderOptions);
    }
    //  If this Circle has children
    //  we call again this function
    if (circle.children) {
      textRenderRecursive(circle.children, context, actualDepth, formatValue, renderOptions);
    }
  });
};
